import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from "utils/axios/axiosBaseQuery";

export const miscApi = createApi({
    reducerPath: 'miscApi',
    baseQuery: axiosBaseQuery({
        baseUrl: "",
    }),
    endpoints: (builder) => ({
    }),
})

export const {
    
} = miscApi;